import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';

export const SkeletonLoaderStyles = styled.div`
  width: inherit;
  height: inherit;
  .skeleton-loader-composite {
    background-color: #d2d2d2;
    color: ${baseVariables.color.merch50};
    -webkit-animation: fadein 1s ease-in alternate infinite;
    -moz-animation: fadein 1s ease-in alternate infinite;
    animation: fadein 1s ease-in alternate infinite;
    border-radius: 8px;
  }
  @-webkit-keyframes fadein {
    10% {
      opacity: 0.3;
    }
    25% {
      opacity: 0.35;
    }
    50% {
      opacity: 0.4;
    }
    75% {
      opacity: 0.5;
    }
    100% {
      opacity: 0.6;
    }
  }
  @-moz-keyframes fadein {
    10% {
      opacity: 0.3;
    }
    25% {
      opacity: 0.35;
    }
    50% {
      opacity: 0.4;
    }
    75% {
      opacity: 0.5;
    }
    100% {
      opacity: 0.6;
    }
  }
  @keyframes fadein {
    10% {
      opacity: 0.3;
    }
    25% {
      opacity: 0.35;
    }
    50% {
      opacity: 0.4;
    }
    75% {
      opacity: 0.5;
    }
    100% {
      opacity: 0.6;
    }
  }
`;

export const AEMSkeletonLoaderStyles = styled.div`
  .aem-skeleton-loader {
    aspect-ratio: 570 / 49;
  }
`;
